import axios from "axios";
import { Constants } from '../utils/Constants';

export function validarSenha(id_aula, estacao, senha) {
	return axios.post(`${Constants.baseUrl}/tela-aula/validar-senha`, { id_aula, estacao, senha });
}

export function getPrograma(id_aula, estacao, senha) {
	return axios.post(`${Constants.baseUrl}/tela-aula/get-programa`, { id_aula, estacao, senha });
}

export function getInstrucoes(id_aula, estacao, senha, data) {
	return axios.post(`${Constants.baseUrl}/tela-aula/get-instrucoes`, { id_aula, estacao, senha, data });
}
